import { Modal as ChakraModal, ModalProps } from '@chakra-ui/react';

function Modal(props: ModalProps) {
    return <ChakraModal isCentered {...props} />;
}

export default Modal;
